import React from 'react';
import { useAdminTheme } from '../../contexts/AdminThemeContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { isDarkMode } = useAdminTheme();

  return (
    <footer
      className={`border-t transition-colors duration-300 ${
        isDarkMode
          ? 'bg-skyone-surface-dark border-skyone-border-dark/80'
          : 'bg-skyone-surface border-gray-200'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="text-center">
          <div className={`text-sm transition-colors duration-300 ${
            isDarkMode ? 'text-gray-400' : 'text-gray-600'
          }`}>
            © {currentYear} Stripe Payment Demo. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
